import type { VisitCardDTO } from "@/api/visit_card_client"
import type { VisitCardUpdateFields } from "../hooks/useVisitCard"
import { mergeVisitCardUpdate } from "../hooks/useVisitCard"
import visitCardDemo from "./visit_card_demo.json"

export const DEMO_VISIT_CARD_SESSION_ID = "demo-visit-card"
export const DEMO_VISIT_CARD = visitCardDemo as VisitCardDTO

/** Fresh base snapshot for a new demo playback (empty brand / product_group). */
export function cloneDemoVisitCard(): VisitCardDTO {
  return structuredClone(DEMO_VISIT_CARD)
}

/** Apply one demo visit_card_update fields block; returns next card + flashed flatKeys. */
export function applyDemoVisitCardUpdate(
  card: VisitCardDTO,
  fields: VisitCardUpdateFields,
): { card: VisitCardDTO; flashed: string[] } {
  const flashed = Object.keys(fields.dropdowns ?? {})
  return {
    card: mergeVisitCardUpdate(card, fields),
    flashed,
  }
}
